import {
  SearchContentsResponse,
  CursorSearch,
} from './src/multilingual-translation-v1-content-translation-contents.universal';

export * from './src/multilingual-translation-v1-content-translation-contents.universal.js';

/** @hidden */
export type ContentSearch = {};

/**
 * Retrieves a list of all translation content associated with a site that matches the search query, with optional data aggregation.
 *
 * Note that this method allows you to retrieve all translation content for a site, regardless of which app created it.
 *
 * Use this method to search translation content fields on a site for a given expression, and/or to perform data aggregations on a site's translation content fields.
 *
 *
 * To learn about working with *Search* methods, see _API Query Language_ ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language))
 * and *Sorting and Paging* ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language#the-sort-array) | [REST](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging)).
 * @param search - Search criteria including filter, sort, aggregations, and paging options.
 * @public
 * @requiredField search
 * @permissionId WIX_MULTILINGUAL.CONTENT_READ
 * @applicableIdentity APP
 * @fqn wix.multilingual.translation.content.v1.TranslationContent.SearchContents
 */
export declare function searchContents(
  search: CursorSearch
): Promise<SearchContentsResponse>;
